import * as React from "react";
import Box from "@mui/material/Box";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import bnilogo from "../../assests/images/bni_logo_red.png";

const BniLoader = ({width = "80vw"}) => {
  return (
    <Box
      sx={{
        width: width ? width : "80vw",
        height: "calc( 80vh - 12.05vw - 115px)",
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        justifyContent: "center",
        alignItems: "center",
        pointerEvents:"none",
        overflowY: "hidden",
        ".row":{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px",
        },
        "img":{
          width:"90px"
        },
        ".dot":{
          background: "#cf2030",
          width: "16px",
          height: "16px",
          borderRadius: "50%",
          animation: "bounce 1s infinite",
          transformOrigin: "top",
        },

        ".dot:nth-of-type(2)": {
          
          animationDelay: "0.1s",
      },
      ".dot:nth-of-type(3)": {
          
          animationDelay: "0.25s",
      },
      "@keyframes bounce": {
          "0%": {
              transform: "translateY(0)",
          },
          "50%": {
              transform: "translateY(-20px)",
          },
          "100%": {
              transform: "translateY(0)",
          }
      }

      }}
    >

    <div className="row">
        <span className="dot"></span><span className="dot"></span><span className="dot"></span>
    </div>
    <div>
      <img src={bnilogo} alt="" />
    </div>
        </Box>
  );
};

export default BniLoader;
